import { Error as DisplayError } from '@infl-ts/ui-advocate-components';
import { S$ } from '@infl-ts/util-fp-ts';
import { logError, logQueryError } from '@infl-ts/util-query-errors';
import * as DE from '@nll/datum/lib/DatumEither';
import * as Bool from 'fp-ts/boolean';
import { constNull, flow, pipe } from 'fp-ts/function';
import * as NEA from 'fp-ts/NonEmptyArray';
import * as O from 'fp-ts/Option';
import { Translation } from 'react-i18next';
import { ConsentModal } from './consent-modal';
import { useConsentStatusQuery } from './queries';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var showConsentGenericError = function showConsentGenericError() {
  return /*#__PURE__*/_jsx(Translation, {
    "data-element": "Translation",
    "data-component": "showConsentGenericError",
    "data-source-file": "consent-workflow.tsx",
    children: function children(t) {
      return /*#__PURE__*/_jsx(DisplayError, {
        showReloadPage: true,
        errorMessage: t('We could not load your consent status because of an error on our end.')
      });
    }
  });
};

var logAndShowConsentError = function logAndShowConsentError(msg) {
  return pipe(new Error(msg), logError, function (e) {
    return e ? NEA.of(e) : null;
  }, showConsentGenericError);
};

var ConsentStatusComponent = function ConsentStatusComponent(_ref) {
  var hubName = _ref.hubName,
      _ref$consentConfig = _ref.consentConfig,
      emailOptIn = _ref$consentConfig.emailOptIn,
      fields = _ref$consentConfig.fields,
      flowVariant = _ref$consentConfig.flowVariant,
      children = _ref.children;
  return pipe(useConsentStatusQuery(), DE.map(S$.prop('consentStatus')), DE.squash(constNull, flow(logQueryError, showConsentGenericError), Bool.match(function () {
    return /*#__PURE__*/_jsx(ConsentModal, {
      hubName: hubName,
      emailOptIn: emailOptIn,
      options: fields,
      flowVariant: flowVariant
    });
  }, function () {
    return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
  })));
};

export var ConsentWorkflow = function ConsentWorkflow(_ref2) {
  var config = _ref2.config,
      children = _ref2.children;
  return pipe(config, DE.squash(constNull, flow(logQueryError, showConsentGenericError), function (_ref3) {
    var isPublicPage = _ref3.isPublicPage,
        hubName = _ref3.hubName,
        consentConfig = _ref3.consentConfig;
    if (O.isNone(isPublicPage)) return logAndShowConsentError('Mode settings could not be loaded');
    if (isPublicPage.value || O.isNone(consentConfig)) return /*#__PURE__*/_jsx(_Fragment, {
      children: children
    });
    return /*#__PURE__*/_jsx(ConsentStatusComponent, {
      hubName: hubName,
      consentConfig: consentConfig.value,
      children: children
    });
  }));
};